import { RouteView } from '@/layouts';

const goodsRouter = {
  path: '/goods',
  name: 'Goods',
  redirect: '/goods/cigar',
  component: RouteView,
  meta: {
    title: '商品管理',
    icon: 'iconproduct',
    roles: ['admin'],
  },
  children: [
    {
      path: 'cigar',
      name: 'Cigar',
      component: RouteView,
      redirect: '/goods/cigar/list',
      hideChildrenInMenu: true,
      meta: {
        title: '雪茄',
        icon: 'iconxuejia',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'CigarList',
          component: () => import('@/views/goods/cigar/List'),
          meta: {
            title: '雪茄列表',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'detail',
          name: 'CigarDetail',
          component: () => import('@/views/goods/cigar/Detail'),
          meta: {
            title: '雪茄详情',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'CigarAdd',
          component: () => import('@/views/goods/cigar/Add'),
          meta: {
            title: '雪茄添加',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'editor',
          name: 'CigarEditor',
          component: () => import('@/views/goods/cigar/Editor'),
          meta: {
            title: '雪茄编辑',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
    {
      path: 'finesgoods',
      name: 'finesGoods',
      component: RouteView,
      redirect: '/goods/finesgoods/list',
      hideChildrenInMenu: true,
      meta: {
        title: '配件',
        icon: 'iconcollection',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'FinesGoodList',
          component: () => import('@/views/goods/finesGoods/List'),
          meta: {
            title: '配件列表',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'detail',
          name: 'FinesGoodDetail',
          component: () => import('@/views/goods/finesGoods/Detail'),
          meta: {
            title: '配件详情',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'FinesGoodAdd',
          component: () => import('@/views/goods/finesGoods/Add'),
          meta: {
            title: '配件添加',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'editor',
          name: 'FinesGoodEditor',
          component: () => import('@/views/goods/finesGoods/Editor'),
          meta: {
            title: '配件编辑',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
    {
      path: 'custom',
      name: 'Custom',
      component: RouteView,
      redirect: '/goods/custom/list',
      hideChildrenInMenu: true,
      meta: {
        title: '服务',
        icon: 'iconjewelry',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'CustomList',
          component: () => import('@/views/goods/custom/List'),
          meta: {
            title: '服务列表',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'detail',
          name: 'CustomDetail',
          component: () => import('@/views/goods/custom/Detail'),
          meta: {
            title: '服务详情',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'CustomAdd',
          component: () => import('@/views/goods/custom/Add'),
          meta: {
            title: '服务添加',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'editor',
          name: 'CustomEditor',
          component: () => import('@/views/goods/custom/Editor'),
          meta: {
            title: '服务编辑',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
  ],
};

export default goodsRouter;
